import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SvgIconService {
  constructor(private matIconRegistry: MatIconRegistry, private sanitizer: DomSanitizer, private http: HttpClient) {}

  registerIcons(): Promise<void> {
    return new Promise((resolve) => {
      let settled = false;
      const done = () => {
        if (settled) {
          return;
        }
        settled = true;
        resolve();
      };

      const sub = this.getIconList().subscribe({
        next: (icons: string[]) => {
          icons.forEach((icon) => {
            const nameParts = icon.split('-');
            const color = nameParts.pop();
            const name = nameParts.join('-');
            this.matIconRegistry.addSvgIcon(
              icon,
              this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/icones/${color}/${name}.svg`)
            );
          });
          done();
        },
        error: (err) => {
          console.error('[SvgIconService] Failed to load icons-list.json', err);
          done();
        }
      });

      // Prevent APP_INITIALIZER from hanging forever if the request never completes.
      setTimeout(() => {
        if (!settled) {
          sub.unsubscribe();
          console.error('[SvgIconService] icons-list.json timed out');
          done();
        }
      }, 3000);
    });
  }

  private getIconList(): Observable<string[]> {
    return this.http.get<string[]>('/assets/icones/icons-list.json');
  }
}
